import * as React from "react"
import { CSSProperties } from "react"
import { ProjectData } from "../EntityType"
import MobileCrmData from "../MobileCrmData"
import { ListItemWrapper } from "../list/ListItemWrapper"
import { ListItemStateContent } from "../list/ListItemStateContent"
import { ListItemCallbackProps } from "../list/MobileListDataWrapper"

export type ProjectDataProps = {
	data: ProjectData, table: string,
	style: CSSProperties,
	index: number,
} & ListItemCallbackProps;

const ItemLeftSide = ( props: ProjectDataProps ) => {
	return <>
		<div className={ "itemFirm ellipsis" }>
			<span dangerouslySetInnerHTML={ { __html: props.data.firmName } } />
		</div>
	</>
}
const ItemRightSide = ( props: ProjectDataProps ) => {
	return <>
		{ props.data.dateTo &&
			<div className={ "itemDateNextAction ellipsis" }>{ props.data.dateTo }</div> }
		{
			props.data.permission.assignedUserId.map( ( userId, index ) => (
				<span key={ index }>
					{ MobileCrmData.getUserNameById( userId ) }
 				</span>
			) )
		}
	</>
}
const ItemBasic = ( props: ProjectDataProps ) => {
	return <ListItemStateContent statusColor={ props.data.statusColor } statusName={ props.data.statusName } isClosed={ props.data.isClosed } />
}

export const ProjectListItem = ( props: ProjectDataProps ) => {
	return <ListItemWrapper
		tagColor={ props.data.statusColor }
		name={ props.data.name } table={ props.table }
		permission={ props.data.permission } id={ props.data.id }
		isClosed={ props.data.isClosed }
		itemExpandLeftElement={ <ItemLeftSide { ...props } /> }
		itemBasicElement={ <ItemBasic { ...props } /> }
		itemExpandRightElement={ <ItemRightSide { ...props } /> }
		style={ props.style } index={ props.index }
		onDeleteItemCallback={ props.onDeleteItemCallback }
		onEditItemCallback={ props?.onEditItemCallback }
		onListMessageCallback={ props.onListMessageCallback }
		onLoadingStart={props.onLoadingStart}
	/>
}
